import PropTypes from 'prop-types';
import CardBackgroundImpl from './card-background.js';
import MojitoCore from 'mojito/core';

/**
 * Shared card background: promotion artwork when supplied, otherwise the sport watermark.
 *
 * @function CardBackground
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Background
 */

/**
 * `CardBackground` component prop types.
 *
 * @property {string} sportId - Sport id used to render the watermark when no promotion image is shown.
 * @property {string} [imgUrl] - Promotion artwork painted behind the card. A load failure falls back to the watermark.
 * @property {Mojito.Presentation.Components.SportWatermarkImageTypes.POSITIONS} [position] - Corner placement of the watermark glyph. Defaults to top right.
 *
 * @memberof Mojito.Modules.EventCards.Background.view
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    imgUrl: PropTypes.string,
    position: PropTypes.string,
};

export default MojitoCore.Presentation.UIView('CardBackground', CardBackgroundImpl, propTypes);
